import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EvaluationsComponent } from './evaluations.component';
import { EvaluationsViewComponent } from './evaluations-view/evaluations-view.component';

const routes: Routes = [
  { path: '', component: EvaluationsComponent },
  { path: 'view/:id', component: EvaluationsViewComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EvaluationsRoutingModule { }
